import { CustomElement } from '@aurelia/runtime-html';
import * as d0 from "../../components/info/event-presenter.ts";
import "./present.scss";
export const name = "present-event";
export const template = "<template>\n  \n  \n\n  <div if.bind=\"isLoading\" class=\"text-center mt-4\">\n    <span class=\"fas fa-spinner fa-spin fa-2x text-muted\" aria-hidden=\"true\"></span>\n  </div>\n\n  <event-presenter if.bind=\"!isLoading\" event.to-view=\"event\" schedules.to-view=\"schedules\"\n    groups.to-view=\"groups\" on-cancel.to-view=\"onCancelCallback\"\n    statistics.to-view=\"statistics\" comments.to-view=\"comments\"></event-presenter>\n\n</template>\n";
export default template;
export const dependencies = [ d0 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
